import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency';

class SettingsPayoutAddMethodPayoneerSetupController extends Controller {
  @service('error-tracker') errorTracker;
  @service('commands/payout-account-commands') payoutAccountCommands;
  @service session;

  @dropTask
  *createPayoutAccount() {
    try {
      const payoutAccount = yield this.payoutAccountCommands
        .createPayoneerPayoutAccountForUser(this.session.currentUser);

      this.set('model.payoutAccount', payoutAccount);
      this.openPayoneer();
    } catch (error) {
      this.errorTracker.error(error, this);
    }
  }

  openPayoneer() {
    window.open(this.model.payoutAccount.registrationLink, '_self');
  }

  @action
  handleCreatePayoutAccount() {
    return this.createPayoutAccount.perform();
  }

  @action
  handleOpenPayoneer() {
    this.openPayoneer();
  }
}

export default SettingsPayoutAddMethodPayoneerSetupController;
